import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import AdminPicker from '../../../components/AdminPicker/AdminPicker'
import { useAuth, useProtectedPage, useSetManager } from '../../../context/AuthContext'
import callAPI from '../../../helpers/callAPI'
import useQueryParams from '../../../hooks/useQueryParams'
import Affiliate from '../../../templates/Affiliate/Affiliate'
import Campaign from '../../../templates/Campaign/Campaign'
import Dollars from '../../../templates/Dollars/Dollars'
import ReportTable from '../../../templates/ReportTable/ReportTable'
import Loading from '../../../templates/UI/Loading/Loading'

const ReportAffiliateEarningChanges = ({ showSystemMessage }) => {
    let auth = useAuth()
    useProtectedPage(auth.permissions, 'affiliates_top')
    let showManagerDropdown = useSetManager(auth.permissions, 'affiliates_top')
    const { adminId, setAdminId, buildUrl } = useQueryParams()

    const history = useHistory()
    const location = useLocation()
    const [dataLoaded, setDataLoaded] = useState(false)
    const [report, setReport] = useState({})
    const [mode, setMode] = useState('increased')

    useEffect(() => {
        getReport()
    }, [location])

    const getReportOutput = () => {
        let columns = [
            {
                Header: 'ID',
                accessor: 'id',
                Cell: (tableData) => {
                    return <>{tableData.data[tableData.row.index].affiliate.id}</>
                },
            },
            {
                Header: 'Affiliate',
                accessor: 'name',
                Cell: (tableData) => {
                    return <Affiliate aid={tableData.data[tableData.row.index].affiliate.id} name={tableData.data[tableData.row.index].affiliate.name} status={tableData.data[tableData.row.index].affiliate.status} priority={tableData.data[tableData.row.index].affiliate.priority} />
                },
            },
            {
                Header: <div style={{ textAlign: 'right' }}>Avg Earnings</div>,
                accessor: 'avg_earnings',
                className: 'text-right',
                Cell: ({ cell: { value } }) => {
                    return <Dollars value={value} />
                },
            },
            {
                Header: <div style={{ textAlign: 'right' }}>Current Earnings</div>,
                accessor: 'current_earnings',
                className: 'text-right',
                Cell: ({ cell: { value } }) => {
                    return <Dollars value={value} />
                },
            },
        ]

        return (
            <React.Fragment>
                <ReportTable data={mode === 'increased' ? report.increased : report.dropped} columns={columns} />
            </React.Fragment>
        )
    }

    const refreshReport = (e) => {
        e.preventDefault()

        let url = buildUrl(`/affiliates/earningChanges?`)
        history.push(url)
    }

    const getReport = () => {
        setDataLoaded(false)

        let url = buildUrl(`affiliates/earningChanges?`)

        callAPI(url, 'GET')
            .then((result) => {
                if (result['success'] === true) {
                    setReport({ increased: result.increased_affiliates, dropped: result.dropped_affiliates })
                } else if (result['success'] === false) {
                    showSystemMessage('error', result.errors.message)
                }

                setDataLoaded(true)
            })
            .catch((error) => {
                console.log(`Error while fetching affiliate earning changes: ${error}`)
                showSystemMessage('error', 'An error occurred while fetching affiliate earning changes')
            })
    }

    return (
        <div>
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1">Reports</h1>
            </div>
            <div className="row">
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-body p-0">
                            <div className="d-flex p-3">
                                <div className="mr-4 d-flex align-items-center">
                                    <h1 className="mb-h1-dark">Affiliate Earning Changes (24h)</h1>
                                </div>
                                <select className="form-control form-control-sm mr-4 w-25" name="type" onChange={(e) => setMode(e.target.value)}>
                                    <option value="increased">Increased</option>
                                    <option value="dropped">Dropped</option>
                                </select>
                                {showManagerDropdown && (
                                    <>
                                        <div className="mr-4">
                                            <AdminPicker adminId={adminId} setAdminId={setAdminId} role={['AM_JUNIOR', 'AM_SENIOR', 'AM_JR_TEAMLEAD']} />
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <button onClick={refreshReport} className="btn btn-sm btn-primary">
                                                Refresh Report
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                            {/* {dataLoaded ? mode === 'increased' ? report.increased.length === 0 : report.dropped.length === 0 ? <div className="p-3">No stats for the current parameters.</div> : getReportOutput() : <Loading />} */}

                            {dataLoaded ? report[mode].length === 0 ? <div className="p-3">No stats for the current parameters.</div> : getReportOutput() : <Loading />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReportAffiliateEarningChanges
